<template>
        <div class="c-product-pants-sizes u-fullwidth u-pos-relative">
            <div class="waist-wrapper u-flex">
                <span v-for="size in waistSizes" class="size-header__waist">
                    {{ size }}
                </span>
            </div>
            <div class="sizes-wrapper">
                <div v-for="row in items" class="u-flex sizes-row">
                    <v-shop-product-pants-size-input :is-admin="isAdmin" v-for="(variant, index) in row" :key="index" :item.sync="variant" :disabled="readOnly" ref="sizeInputs" :showStockForPreOrder="showStockForPreOrder"></v-shop-product-pants-size-input>
                </div>
            </div>
            <div class="length-wrapper">
                <div v-for="size in lengthSizes" class="size-header__length" :class="{'pre-order-stock': showStockForPreOrder}">
                    {{ size }}
                </div>
            </div>
        </div>
    </template>
    
    <script>
        import VInput from '@/components/form/Input'
        import VShopProductPantsSizeInput from '@/components/product/widgets/productPantsSizeInput'

        export default {
            props: {
                items: Array,
                waistSizes: Array,
                lengthSizes: Array,
                isAdmin: { type: Boolean, default: false },
                readOnly: { type: Boolean, default: false },
                showStockForPreOrder: { type: Boolean, default: false }
            },
            computed: { },
            methods: { },
            components: {
                VInput,
                VShopProductPantsSizeInput
            }
        }
    </script>
    
    <style lang="scss" scoped>

        @import "~@/assets/scss/private";

        .c-product-size {
            border: 1px dashed palette(color-neutral, light);
            padding: em($global-spacing-unit-small);

            &.is-valid{
                border-color: $color-success;
                border-style: solid;
                background-color: rgba($color-success, .05);
            }

            &.is-invalid{
                border-color: $color-error;
                border-style: solid;
                background-color: rgba($color-error, .05);
            }

            &.is-disabled{
                opacity:.5;
            }
        }

        .c-product-size__stock {
            border: 1px solid transparent;
            &.is-invalid{
                border: 1px solid $color-error;
            }
        }

        .waist-wrapper,
        .sizes-wrapper {
            padding-left: 60px;
            margin-bottom: 10px;
        }

        .size-header__waist {
            display: inline-block;
            width: 15%;
            text-align: center;
            font-weight: bold;
            color: lighten($color-base, 20%);
            font-size: em(15px);
            background-color: lighten($color-base, 80%);
            margin-right: 10px;
            padding: 5px 0;
        }

        .size-header__length {
            height: 125px;
            font-weight: bold;
            line-height: 8em;
            margin-bottom: 10px;
            padding: 0 10px;
            font-size: em(15px);
            text-align: center;
            color: lighten($color-base, 20%);
            background-color: lighten($color-base, 80%);
        }

        .length-wrapper {
            position: absolute;
            left: 0;
            top: 41px;
        }

        .pre-order-stock {
            height: 160px;
        }
    </style>

    <style lang="scss">

        @import "~@/assets/scss/private";

        .c-product-size {
            max-width: 120px;
            min-width: 80px;

            .sizes-wrapper & {
                max-width: none;
                min-width: auto;
            }
            label {
                margin-bottom: em($global-spacing-unit-tiny);
            }
        }
    </style>


// WEBPACK FOOTER //
// src/components/product/widgets/productPantsSizes.vue